import * as React from 'react';

import * as styles from './RowTitlePhotosField.css';

export const RowTitlePhotosField = ({ children }: React.PropsWithChildren): React.JSX.Element => {
  return <div className={styles['container']}>{children}</div>;
};
